import gql from "graphql-tag";

export function useCount(modelName: string) {
    return gql`
        query($filter: MongooseFilterDto${modelName}){
            count${modelName}(filter: $filter)
        }
    `;
}
